import React from "react";
import { InputValueType } from "@origin-digital/ods-types";
import { HelperTextNodeProps } from "./types";

/**
 * Hook to manage state of <TextField />
 */
export const useTextFieldState = (
  initialFieldValue: InputValueType | undefined,
  showCharacterCount = false
) => {
  const [helperTextNodeProps, setHelperTextNodeProps] =
    React.useState<HelperTextNodeProps>({
      message: undefined,
      value: initialFieldValue,
      showCharacterCount,
    });
  const [error, setError] = React.useState<string>("");
  const [focus, setFocus] = React.useState<boolean>(false);
  const [changed, setChanged] = React.useState<boolean>(false);
  const [startValidatingOnChange, setStartValidatingOnChange] =
    React.useState<boolean>(false);

  return {
    error,
    focus,
    changed,
    startValidatingOnChange,
    setStartValidatingOnChange,
    onFocus: () => setFocus(true),
    onChange: (newValue: InputValueType) => {
      setHelperTextNodeProps((prev) => ({
        ...prev,
        message: error,
        value: newValue,
      }));
      setChanged(true);
    },
    onBlur: () => {
      setChanged(true);
      setFocus(false);
    },
    setError: (
      message: string | undefined,
      currentValue: string | undefined
    ) => {
      if (message) {
        setHelperTextNodeProps((prev) => ({
          ...prev,
          message,
          value: currentValue,
        }));
        setError(message);
      } else {
        setHelperTextNodeProps((prev) => ({
          ...prev,
          message: undefined,
          value: currentValue,
        }));
        setError("");
      }
    },
    helperTextNodeProps,
  };
};
